__turbopack_context__.v({
  "accordionSlideOverwrite": "homeButton-module-scss-module__rTS2HW__accordionSlideOverwrite",
  "fadeIn": "homeButton-module-scss-module__rTS2HW__fadeIn",
  "fadeOut": "homeButton-module-scss-module__rTS2HW__fadeOut",
  "homeButton": "homeButton-module-scss-module__rTS2HW__homeButton",
  "scaleIn": "homeButton-module-scss-module__rTS2HW__scaleIn",
  "scaleOut": "homeButton-module-scss-module__rTS2HW__scaleOut",
  "zoomIn": "homeButton-module-scss-module__rTS2HW__zoomIn",
  "zoomOut": "homeButton-module-scss-module__rTS2HW__zoomOut",
});
